import { http } from 'msw';

export const handlers = [
  http.get('https://www.gravatar.com/avatar/*', () => {
    return new Response('mock-gravatar-image', {
      status: 200,
      headers: {
        'Content-Type': 'image/png',
      },
    });
  }),
];
